import MyExpApi from "apps/myExperience/enum/MyExpApi";
import { useGetApiData, usePostApiData } from "shared/datalayer";
import CommonApi from "shared/enums/CommonApi";
import { useCopies } from "shared/hooks/useCopies";
import { ApiBulkTicketTransfer } from "shared/types/ApiBulkTicketTransfer";
import { ApiRegistrationParticipantSearchResult } from "shared/types/ApiRegistrationParticipantSearchResult";
import { successToast } from "shared/utils/toastNotification";

export function useGetBulkTicketAdminsList(registrationParticipantId?: string) {
  return useGetApiData<Array<ApiRegistrationParticipantSearchResult>>(
    MyExpApi.BULK_TICKET_ADMIN_LIST,
    {
      params: { registrationParticipantId }
    },
    {
      enabled: Boolean(registrationParticipantId)
    }
  );
}

export function useTransferBulkTicketByBulkTicketAdmin() {
  const copies = useCopies();
  return usePostApiData<ApiBulkTicketTransfer>(CommonApi.BULK_TICKET_LOT_TRANSFER, {
    onSuccess: () => {
      successToast(copies.get("bulk.ticket.transfer.successfully"));
    }
  });
}
